
      // this file is automatically generated by git.version.ts script
      export const versions = {
        version: '0.0.0',
        revision: 'b5de8c8',
        branch: 'dev-peri'
      };